import { Component, OnInit, Input, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-turns-forms-card',
  templateUrl: './turns-forms-card.component.html',
  styleUrls: ['./turns-forms-card.component.scss']
})
export class TurnsFormsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('forms-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('forms-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.length;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('forms-counts-spinner');
    }
  }
}
